export default "__VITE_ASSET__BVJtl7hJ__"